var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticStyle:{"float":"right"},attrs:{"size":"mini","type":"primary","disabled":_vm.disabled,"to-name":_vm.toName,"to-params":_vm.toParams},on:{"click":_vm.onClick}},[_c('i',{staticClass:"fas fa-plus"}),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(" "+_vm._s(_vm.$t('create')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }